import React,{ Component } from 'react';

import {
  Popover,
  PopoverHeader,
  PopoverBody
} from 'reactstrap';

import CloseSVG from '../../../shared/assets/close.svg';

class TutorialPopover extends Component {
  render(){
    return (
      <Popover
        placement={this.props.placement}
        isOpen={this.props.open}
        target={this.props.target}
        className='TutorialPopover'
      >
        <img
          src={CloseSVG}
          alt='Close'
          style={{
            position:'absolute',
            right:'0.8rem',
            top:'0.8rem',
            height:12,
            cursor:'pointer'
          }}
          onClick={() => this.props.onCloseClick()}
        />
        <PopoverHeader>
          {this.props.title}
        </PopoverHeader>
        <PopoverBody>
          {this.props.children}
        </PopoverBody>
      </Popover>
    )
  }
}

TutorialPopover.defaultProps = {
  title:'',
  target:'',
  onCloseClick:() => {},
  open:false,
  placement:'right'
};

export default TutorialPopover;



// WEBPACK FOOTER //
// ./src/shared/components/TutorialPopover/index.js